import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const LineChart = React.memo(function LineChart({
  showLegend,
  title,
  yAxisTitle,
  colors,
  data = [],
  decimals = 2,
  day = false,
  suffix = false,
  height = 335,
  type,
}) {
  const chartData = data.map((item) => ({
    ...item,
    type: "area",
    fillColor: "transparent",
    name: item.marketName,
    data: item.chart.map((chart) => [chart.date, chart.value]),
    lineWidth: 0.8,
    marker: {
      enabled: false,
      symbol: "circle",
    },
  }));
  const miniMizeValue = chartData
    .map((item) => item.data)
    .flat()
    .map((tt) => tt[1]);
  const max1 = Math.max(...miniMizeValue);
  const min1 = Math.min(...miniMizeValue);
  const options = {
    chart: {
      type: "area",
      zoomType: "x",
      height: height,
      backgroundColor: "transparent",
      animation: false,
      // events: {
      //   load: function () {
      //     this.yAxis[0].setExtremes(null, null, false);
      //     // console.log(min1, max1);
      //   },
      // },
    },
    credits: {
      enabled: false,
    },
    colors: [...colors],
    title: {
      text: undefined,
    },
    tooltip: {
      valueDecimals: decimals,
      valueSuffix: suffix ? ` ${yAxisTitle}` : "",
      xDateFormat: type === "Hourly" ? "%e %b, %H:%M" : "%A %b %e %Y",
    },
    xAxis: {
      type: "datetime",
      dateTimeLabelFormats: {
        day: "%e-%b",
      },
      labels: {
        y: 28,
        format:
          type === "Hourly"
            ? "{value:%e %b}"
            : day
            ? "{value:%e %b}"
            : "{value:%b'%y}",
        style: {
          textOverflow: "visible",
          whiteSpace: "nowrap",
        },
      },
    },
    yAxis: {
      // max: max1,
      // min: min1,
      // startOnTick: true,
      // endOnTick: true,
      tickAmount: 5,
      lineWidth: 0,
      labels: {
        formatter: function formatter() {
          return String(Number(this.value.toFixed(decimals)));
        },
      },
      title: {
        text: yAxisTitle,
        style: {
          fontFamily: "Roboto",
          fontWeight: "500",
          fontSize: "12px",
          lineHeight: "18px",
          color: "black",
        },
      },
    },

    plotOptions: {
      series: {
        label: {
          connectorAllowed: false,
        },
        animation: false,
      },
    },
    legend: {
      enabled: showLegend === false ? false : true,
      align: "center",
      symbolPadding: 10,
      itemStyle: {
        fontFamily: "Roboto",
        fontWeight: "500",
        fontSize: "12px",
        color: "black",
      },
    },
    time: {
      useUTC: true,
    },
    series: [...chartData],
  };
  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
});

export default LineChart;
